import React from "react";
import TextField from "@mui/material/TextField";

// Keep native input attributes on the actual input (labels, constraints, refs).
const TextInput = React.forwardRef(function TextInput(
  {
    className,
    style,
    sx,
    value,
    defaultValue,
    onChange,
    onBlur,
    onFocus,
    disabled,
    autoFocus,
    type,
    id,
    name,
    placeholder,
    error,
    helperText,
    label,
    fullWidth,
    multiline,
    rows,
    minRows,
    maxRows,
    endAdornment,
    children,
    ...inputProps
  },
  ref,
) {
  return (
    <TextField
      className={className}
      style={style}
      sx={sx}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      autoFocus={autoFocus}
      type={type}
      id={id}
      name={name}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      label={label}
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      minRows={minRows}
      maxRows={maxRows}
      inputRef={ref}
      slotProps={{ htmlInput: inputProps, input: { endAdornment } }}
    />
  );
});
export default TextInput;
